import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { jwtDecode } from "jwt-decode";
import { Router } from '@angular/router';
import { NotificationService } from '../core/services/notification/notification.service';
import { IUserLogIn } from './IUserLogIn';
import { IUserAuth } from '../core/services/authentication/IUserAuth';
import { RestCallOriginService } from '../core/services/rest-call/rest-call-origin.service';
import { TranslateService } from '../core/services/translate-service';

@Injectable({
  providedIn: 'root'
})
export class LoginService extends RestCallOriginService {

  constructor(
    public httpClient: HttpClient,
    public toastr: ToastrService,
    public notificationService: NotificationService,
    public translate: TranslateService,
    private router: Router
  ) {
    super(httpClient, 'MiAplicacionApi', toastr, notificationService, translate);
  }

  public login(user: IUserLogIn) {
    return this.post<string>('Authentication/Login', user);
  }

  public generateAuthentication(token: string): void {
    localStorage.clear();
    var jwt = jwtDecode(token);
    
    localStorage.setItem("token", token);
    localStorage.setItem("expiration", jwt.exp.toString());

    let user: IUserAuth = {
      id: jwt["Id"],
      name: jwt["given_name"],
      userName: jwt["unique_name"],
      email: jwt["email"],
      permission: JSON.parse(jwt["Permission"])
    }

    localStorage.setItem("user", JSON.stringify(user));
    this.router.navigate(['main'])
  }

  public getUser(): IUserAuth {
    return JSON.parse(localStorage.getItem("user"));
  }
}
